/** 
 * @constant LANG_OPTIONS<Record<string, string>>
*/
export const LANG_OPTIONS = {
    "es": "es-ES",
    "en": "en-US",
    "fr": "fr-FR",
}; 